<template>
  <div class="choose-med-wrap">
    <van-sticky offset-top="0">
      <div class="first-nav">
        <div
          class="item"
          :class="{ active: showFirstFlag }"
          @click="showFirstFlag = true"
        >
          用药套餐<span v-show="packageNum != 0" class="num">{{
            packageNum
          }}</span>
        </div>
        <div
          class="item"
          :class="{ active: !showFirstFlag }"
          @click="showFirstFlag = false"
        >
          农资商品<span class="num" v-show="goodsNum != 0">{{ goodsNum }}</span>
        </div>
        <div class="make-sure active" @click="clickGoods">确定</div>
      </div>
    </van-sticky>
    <div class="first-container" ref="first_container">
      <div class="package-item" v-show="showFirstFlag">
        <van-radio-group v-model="firstResult">
          <ul class="package-ul">
            <li
              v-for="(item, index) in groups"
              :key="index"
              @click="choosePackage(index, item)"
            >
              <div class="title">
                <van-radio
                  :name="index"
                  ref="checkboxes"
                  checked-color="#FF9922"
                  icon-size="18px"
                  >{{ item.name }}</van-radio
                >
              </div>
              <div class="box-wrap">
                <div
                  class="list-wrap"
                  :style="{ width: item.durgs.length * 135 + 'px' }"
                >
                  <div class="list" v-for="(e, inx) in item.durgs" :key="inx">
                    <div class="box">
                      <van-image
                        width="100"
                        height="100"
                        lazy-load
                        :src="e.image"
                      >
                        <template v-slot:error>加载失败</template></van-image
                      >
                      <p class="p1 van-multi-ellipsis--l2">{{ e.title }}</p>
                    </div>
                    <div class="add" v-show="inx != item.durgs.length - 1">
                      +
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-radio-group>
        <van-collapse v-model="activeName" class="collapse-box1" accordion>
          <van-collapse-item name="1" :disabled="showChoosePack">
            <div slot="title">
              已选
              <span class="title-num">{{
                showChoosePack ? "" : choosedPackNum
              }}</span>
            </div>
            <div class="package-choosed-box">
              <van-icon name="close" class="close" @click="firstResult = -1" />
              <p class="p1">{{ choosedPackText }}</p>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <!-- 选择商品 -->
      <div class="goods-item" v-show="!showFirstFlag">
        <div class="goods-bar">
          <div
            class="item"
            :class="{ active: goodsIndex == index }"
            v-for="(item, index) in goodsNav"
            :key="index"
            @click="chooseGoodsbar(index, item.id)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
        <van-loading v-show="loading" color="#1989fa" />
        <van-checkbox-group v-show="!loading" v-model="result">
          <ul class="goods-list-box">
            <li
              v-for="(goods, i) in goodsList"
              :key="i"
              clickable
              @click="toggleGoods(i, goods.title)"
              ref="li"
            >
              <div class="wrap">
                <van-checkbox
                  slot="right-icon"
                  :name="goods"
                  ref="lis"
                  class="check"
                  checked-color="#FF9922"
                />
                <van-image :src="goods.image" />
                <h6 class="h6">{{ goods.title }}</h6>
                <p class="van-multi-ellipsis--l3">{{ goods.content }}</p>
              </div>
            </li>
          </ul>
        </van-checkbox-group>
        <van-collapse
          v-model="activeGoodsNames"
          accordion
          class="choosedGoodsFlag"
        >
          <van-collapse-item
            name="1"
            class="goods-coll"
            :disabled="chenckDisabled"
          >
            <div slot="title">已选商品 {{ result.length }} 种</div>
            <ul class="goods-coll-ul">
              <li v-for="(item, index) in result">
                <span class="text van-ellipsis">{{ item.title }}</span>
                <van-icon
                  name="close"
                  class="close"
                  @click="checkOutGoods(index)"
                />
              </li>
            </ul>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import axios from "../../http";
export default {
  name: "choose_med",
  components: {},
  props: {},
  data() {
    return {
      showFirstFlag: false, //第一级导航
      packageNum: 0, //套餐导航数字
      goodsNum: 0, //用药导航数字
      firstResult: -1,
      choosedPackNum: "", //选中的套餐几
      choosedPackText: "", //选中的套餐文案
      groups: [], //套餐数据,
      showChoosePack: true, //套餐手风琴栏目禁用
      activeName: "0", //手风琴效果
      goodsIndex: 0, //农资商品选择种类索引
      goodsNav: [], //用药的导航
      result: [],
      goodsList: [],
      loading: false, //加载商品列表
      chenckDisabled: true,
      activeGoodsNames: "",
      durpId: "", //套餐id
      goodsId: "" //商品id 字符串
    };
  },
  computed: {
    ...mapState(["user_region_id"]),
    goodsIdList() {
      let arr = [];
      this.result.forEach(el => {
        arr.push(el.id);
      });
      return arr.join(",");
    },
    goodsNameList() {
      let arr = [];
      this.result.forEach(el => {
        arr.push(el.title);
      });
      return arr;
    }
  },
  watch: {
    firstResult(newVal) {
      if (newVal == -1) {
        this.activeName = "0";
        this.showChoosePack = true;
        this.choosedPackNum = "";
      } else {
        this.activeName = "1";
        this.showChoosePack = false;
      }
    },
    result(newVal) {
      //选中的商品变化，手风琴也跟随变化
      if (newVal.length == 0) {
        this.activeGoodsNames = "";
        this.chenckDisabled = true;
      } else {
        this.activeGoodsNames = "1";
        this.chenckDisabled = false;
      }
    }
  },
  mounted() {
    this.getGroups();
    this.getDurgs(); //获取商品分类列表
    this.getGoodsList(0); // 默认获取全部的商品数据
  },
  destroyed() {},
  methods: {
    ...mapMutations(["getDurgIds", "getDurgGroupId"]),
    getGroups() {
      //获取用药套餐
      this.loading = true;
      axios
        .fetchPost("/api/durgs/groups", {
          page_size: 10,
          last_id: 0,
          region_id: this.user_region_id
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.loading = false;
            this.groups = data.data.list;
            // console.log("res :", res.data.data);
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    },
    choosePackage(index, item) {
      //套餐单选
      //单选号效果
      if (index == this.firstResult) {
        // 当点击原来的radio
        this.firstResult = -1;
        this.showChoosePack = true;
      } else {
        this.showChoosePack = false;
        this.firstResult = index;
        this.choosedPackNum = item.name; // 选中的套餐
        this.durpId = item.id;
        this.choosedPackText = "";
        item.durgs.forEach((element, index, arr) => {
          //选中的套餐文案
          if (index == arr.length - 1) {
            this.choosedPackText += element.title;
            return;
          }
          this.choosedPackText += element.title + "+";
        });
      }
    },
    getDurgs() {
      //获取商品分类列表
      axios.fetchPost("/api/type/durgs").then(res => {
        if (res.data.code == 200) {
          this.goodsNav = res.data.data;
        }
      });
    },
    chooseGoodsbar(index, id) {
      //商品分类nav，全部，除草剂等等
      this.goodsIndex = index;
      this.getGoodsList(id); //点击导航，请求对应的数据
    },
    getGoodsList(cate_id, last_id) {
      axios
        .fetchPost("/api/durgs/lists", {
          page_size: 20,
          last_id: last_id,
          region_id: this.user_region_id,
          cate_id: cate_id
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.goodsList = data.data.list;
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    },
    toggleGoods(index, item) {
      //商品分类列表内的复选框按钮
      this.$refs.lis[index].toggle();
    },
    checkOutGoods(ins) {
      //删除手风琴效果内的选中商品
      this.result.forEach((el, index, arr) => {
        if (index == ins) {
          if (arr.length == 1) {
            //只有一条数据的时候
            this.result = [];
            return;
          }
          this.result.splice(ins, 1);
        }
      });
    },
    clickGoods() {
      this.getDurgIds({
        id: this.durpId,
        name:
          this.goodsNameList.length >= 1 && this.choosedPackNum
            ? this.choosedPackNum + ","
            : this.choosedPackNum
      });
      this.getDurgGroupId({
        id: this.goodsIdList,
        name:
          this.goodsNameList.length == 0
            ? ""
            : `商品${this.goodsNameList.length}种`
      });
      this.$router.push({
        path: "/secondBar/medication"
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.choose-med-wrap
  background #efefef
  .first-nav
    display flex
    border 1px solid #E5E5E5
    background #fff
    align-items center
    & > .item
      width 50%
      flex 1
      height 45px
      line-height 45px
      font-size 18px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(152, 152, 152, 1)
      .num
        position relative
        display inline-block
        font-size 12px
        top -10px
      &.active
        color #55CC99
        .num
          color #55CC99
      &:first-child
        border-right 1px solid #E5E5E5
    .make-sure
      width 55px
      height 28px
      border-radius 40px
      line-height 28px
      margin-right 13px
      background #B3B3B3
      color #fff
      &.active
        background rgba(85, 204, 153, 1)
  .first-container
    padding-bottom 50px
    .package-item
      .package-ul
        li
          margin-top 10px
          position relative
          padding 47px 0 17px 12px
          background #fff
          width 100%
          overflow auto
          .title
            position absolute
            left 12px
            top 14px
          .box-wrap
            width 100%
            overflow auto
            text-align left
            .list-wrap
              width auto
              .list
                display inline-block
                .box
                  width 100px
                  background rgba(255, 255, 255, 1)
                  display inline-block
                  // vertical-align middle
                  .goods-img
                    width 100px
                    display block
                    height 100px
                    border 1px solid rgba(229, 229, 229, 1)
                  .p1
                    font-size 14px
                    font-family Microsoft YaHei
                    font-weight 400
                    color rgba(40, 40, 40, 1)
                    line-height 20px
                .add
                  display inline-block
                  vertical-align top
                  margin-top 45px
                  width 35px
                  text-align center
      .collapse-box1
        text-align left
        border-top 1px solid #e5e5e5
        position fixed
        bottom 0px
        left 0
        right 0
        .title-num
          color #FF9922
        .package-choosed-box
          position relative
          padding-right 50px
          .close
            position absolute
            right 10px
            top 0px
            font-size 20px
    .goods-item
      .goods-bar
        display flex
        background #ffff
        border-bottom 1px solid #e5e5e5
        & > .item
          flex 1
          text-align center
          height 45px
          font-size 16px
          font-family Microsoft YaHei
          font-weight 400
          line-height 45px
          color rgba(152, 152, 152, 1)
          &.active
            color #55CC99
            span
              display inline-block
              height 100%
              border-bottom 2px solid #55CC99
      .goods-list-box
        width 100%
        padding 10px
        padding-bottom 0
        display flex
        flex-wrap wrap
        li
          text-align left
          width 50%
          background #efefef
          margin-bottom 10px
          position relative
          &.border
            border 1px solid #ff6600
          .wrap
            background #fff
            padding-bottom 15px
            min-height 260px
          &:nth-child(odd)
            padding-right 5px
          &:nth-child(even)
            padding-left 5px
          .van-image
            width 120px
            height 170px
            display block
            margin 0 auto
          .h6
            width 90%
            font-size 14px
            font-family Microsoft YaHei
            font-weight 400
            margin 12px auto 5px
            line-height 1.2
            color rgba(40, 40, 40, 1)
          p
            width 90%
            font-family Microsoft YaHei
            font-weight 400
            font-size 12px
            color rgba(152, 152, 152, 1)
            line-height 13px
            margin 0 auto
          .check
            position absolute
            right 5px
            top 5px
    .goods-coll
      text-align left
      /deep/.van-collapse-item__content
        padding-top 0
        padding-right 0
        .goods-coll-ul
          li
            height 40px
            line-height 40px
            display flex
            align-items center
            color #282828
            border-bottom 1px solid #efefef
            .text
              flex 1
              overflow hidden
            .close
              font-size 20px
              margin 0 28px 0 10px
              color #C7C7C7
  .choosedGoodsFlag
    position fixed
    bottom 0
    left 0
    right 0
    max-height 50%
    overflow auto
</style>
